module.exports = __webpack_public_path__ + "static/media/memories.2f584e9f.png";